import React from "react";

export interface AiConfidenceBarProps {
  /** Score on 0–1 scale */
  score?: number | null;
  className?: string;
}

const getPercent = (score?: number | null): number => {
  if (score == null || Number.isNaN(score)) return 0;
  return Math.min(100, Math.max(0, Math.round(score * 100)));
};

const getBarClass = (percent: number): string => {
  if (percent >= 85) return "xgs-ai-confidence-bar__fill--high";
  if (percent >= 60) return "xgs-ai-confidence-bar__fill--medium";
  return "xgs-ai-confidence-bar__fill--low";
};

const AiConfidenceBar: React.FC<AiConfidenceBarProps> = ({ score, className = "" }) => {
  const percent = getPercent(score);

  return (
    <div className={`xgs-ai-confidence-bar ${className}`.trim()}>
      <div className="xgs-ai-confidence-bar__label-row">
        <span className="xgs-ai-confidence-bar__title">AI Confidence</span>
        <span className="xgs-ai-confidence-bar__percent">{percent}%</span>
      </div>
      <div className="xgs-ai-confidence-bar__track">
        <div
          className={`xgs-ai-confidence-bar__fill ${getBarClass(percent)}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default AiConfidenceBar;
